import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import EmailFetchCredentialsSettingsForm from './EmailFetchCredentialsSettingsForm';
import i18n from 'i18n';

interface EmailFetchCredentialsSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeEmailFetchCredential: number;
}

const EmailFetchCredentialsSettingsModal: React.FC<EmailFetchCredentialsSettingsModalProps> = React.memo(({
    modalOpen,
    closeModal,
    activeEmailFetchCredential,
}) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_email_fetch.text')}
        entityId={activeEmailFetchCredential}
        FormComponent={EmailFetchCredentialsSettingsForm}
    />
));

export default EmailFetchCredentialsSettingsModal; 